import ApiService from '../../services/apiService';
import tenantPickerMixin from '../../components/core/tenant/pickerMixin';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import devicesLimitMixin from '../../components/core/virtualDevice/devicesLimitMixin';
const DEFAULT_WMBUS_MODULE_SETTINGS = {
  wMBus: {
    deviceLimit: 0,
    activeDeviceLimit: false
  }
};
const DEFAULT_LWM2M_MODULE_SETTINGS = {
  LwM2M: {
    deviceLimit: 0,
    activeDeviceLimit: false
  }
};
const RETENTION_POLICY_DEFAULT = 24;
const CSV_EXPORT_LIMIT = 500000;
const TEMPLATE_LIMIT_DEFAULT = 0;
export default {
  name: 'ViewAccountMgmtAccountMgmtModules',
  mixins: [tenantPickerMixin, devicesLimitMixin],
  data: function () {
    return {
      formIsValid: false,
      loadingModules: true,
      modules: [],
      moduleDisablePrompt: false,
      moduleToDisable: null,
      tenantDefaultRoles: [],
      superAdminModuleInteraction: false,
      positiveNumberRule: v => {
        return /^[0-9]+$/.test(v) ? true : this.$i18n_t('DigitalTwin.DigitalTwin.share.mapUrlParamsLabels.ruleError');
      }
    };
  },
  computed: {
    retentionPolicyRules() {
      return [v => !!v && (isNaN(parseFloat(v)) || parseFloat(v) <= 0.1 ? this.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.numberRule') : true) || this.$i18n_t('Common.fieldRequired')];
    },
    hasCustomLimit() {
      return get(this.tenantModel, 'data.useCustomTemplateLimit');
    }
  },
  watch: {
    selectedTenantId() {
      this.fetchTenantModules();
      this.tenantModel.data.retentionPolicyMonths = this.tenantModel.data.retentionPolicyMonths || RETENTION_POLICY_DEFAULT;
      this.tenantModel.data.csvExportLimit = this.tenantModel.data.csvExportLimit || CSV_EXPORT_LIMIT;
      this.tenantModel.data.templateLimit = this.tenantModel.data.templateLimit || TEMPLATE_LIMIT_DEFAULT;
    }
  },
  mounted() {
    this.loadTenants();
  },
  methods: {
    updateRetentionPolicy() {
      if (this.retentionPolicyRules[0](this.tenantModel.data.retentionPolicyMonths) === true) {
        this.updateRetentionPolicyRequest();
      }
    },
    updateRetentionPolicyRequest: debounce(function () {
      ApiService.tenantUpdateRetentionPolicy({
        id: this.tenantModel.id,
        retentionPolicyMonths: this.tenantModel.data.retentionPolicyMonths
      }).catch(error => {
        console.error('Retention-Policy update error', error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          console.error(error);
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
      });
    }, 500),
    updateCsvExportLimit: debounce(function () {
      if (get(this.tenantModel, 'data.csvExportLimit') && !/^[0-9]+$/.test(this.tenantModel.data.csvExportLimit)) {
        return;
      }
      ApiService.tenantUpdateCsvExportLimit({
        id: this.tenantModel.id,
        csvExportLimit: this.tenantModel.data.csvExportLimit
      }).catch(error => {
        console.error('Csv export limit update error', error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          console.error(error);
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
      });
    }, 500),
    updateDeviceTemplateSettings: debounce(function () {
      if (get(this.tenantModel, 'data.templateLimit') && !/^[0-9]+$/.test(this.tenantModel.data.templateLimit)) {
        return;
      }
      ApiService.tenantUpdateTemplatesLimit({
        id: this.tenantModel.id,
        templateLimit: this.tenantModel.data.templateLimit,
        useCustomTemplateLimit: this.tenantModel.data.useCustomTemplateLimit
      }).catch(error => {
        console.error('Device template settings update error', error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          console.error(error);
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
      });
    }, 500),
    confirmModuleDisable(moduleModel, $event) {
      if (moduleModel.manifest.superAdminModule) {
        // this is a super-admin module, but user has no Super-Admin rights
        if (!this.permissions['super.system.manage']) {
          // force refresh/redraw the v-switch
          // cloneDeep does not do the trick (alone) to reset the switch to its "old" value,
          // need to change the key manually here to re-draw it
          moduleModel.tempKey = new Date().toISOString();
          this.modules = cloneDeep(this.modules);
          this.superAdminModuleInteraction = true;
          return;
        }
      }
      moduleModel.isEnabled = $event;
      if (!moduleModel.isEnabled) {
        // user wants to disable and enabled module, so confirm with the user
        this.moduleToDisable = moduleModel;
        this.moduleDisablePrompt = true;
      } else {
        // if a module is enabled, nothing to do here
        this.toggleModule(moduleModel);
      }
    },
    cancelModuleDisablement() {
      if (this.moduleToDisable) {
        this.moduleToDisable.isEnabled = true;
        this.moduleDisablePrompt = false;
        this.moduleToDisable = null;
      }
    },
    toggleModule: debounce(function (moduleModel) {
      if (get(moduleModel, 'settings.deviceLimit') && !/^[0-9]+$/.test(moduleModel.settings.deviceLimit)) {
        return;
      }
      this.moduleDisablePrompt = false;
      this.moduleToDisable = null;
      moduleModel.modulesSettings = moduleModel.modulesSettings || {};
      if (moduleModel.key === this.moduleKeys.wmbus) {
        if (moduleModel.settings.activeDeviceLimit) {
          moduleModel.modulesSettings.wMBus = {
            activeDeviceLimit: moduleModel.settings.activeDeviceLimit,
            deviceLimit: moduleModel.settings.deviceLimit || 0
          };
        } else {
          moduleModel.modulesSettings.wMBus = {
            activeDeviceLimit: moduleModel.settings.activeDeviceLimit
          };
        }
      } else if (moduleModel.key === this.moduleKeys.lwm2m) {
        if (moduleModel.settings.activeDeviceLimit) {
          moduleModel.modulesSettings.LwM2M = {
            activeDeviceLimit: moduleModel.settings.activeDeviceLimit,
            deviceLimit: moduleModel.settings.deviceLimit || 0
          };
        } else {
          moduleModel.modulesSettings.LwM2M = {
            activeDeviceLimit: moduleModel.settings.activeDeviceLimit
          };
        }
      }
      this.loadingModules = true; //moduleModel.key;
      return ApiService.tenantToggleModule(this.selectedTenantId, moduleModel.key, moduleModel.isEnabled, moduleModel.modulesSettings).then(() => {
        return this.fetchTenantModules();
      }).catch(error => {
        moduleModel.isEnabled = !moduleModel.isEnabled;
        // force refresh/redraw the v-switch
        // cloneDeep does not do the trick (alone) to reset the switch to its "old" value,
        // need to change the key manually here to re-draw it
        moduleModel.tempKey = new Date().toISOString();
        this.modules = cloneDeep(this.modules);
        if (get(error, 'response.status') === 401) {
          if (error.response.data.message.startsWith('NO_PERMISSION_')) {
            const rule = error.response.data.message.replace('NO_PERMISSION_', '').split('.');
            if (rule.length >= 2) {
              const subject = this.$i18n_t(`Error.permissions.${rule[0]}`) || rule[0];
              const action = this.$i18n_t(`Error.permissions.${rule[1]}`) || rule[1];
              this.$snack(this.$i18n_t('Error.NO_PERMISSION_', {
                subject,
                action
              }), 'error');
              return;
            }
          }
        }
        console.error('Module toggle error', error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
      }).finally(() => {
        this.loadingModules = false;
      });
    }, 500),
    toggleDefaultRole(role) {
      let defaultRoles = cloneDeep(this.tenantDefaultRoles);
      const roleIsActive = defaultRoles.findIndex(defaultRole => defaultRole.id === role.id) >= 0;
      if (roleIsActive) {
        defaultRoles = defaultRoles.filter(defaultRole => defaultRole.id !== role.id);
      } else {
        defaultRoles.push({
          id: role.id
        });
      }
      this.loadingModules = true; //moduleModel.key;
      ApiService.updateDefaultRoles(this.getTenantById(this.selectedTenantId).scopeId, defaultRoles.map(role => role.id)).then(() => {
        return this.fetchTenantModules();
      }).catch(error => {
        console.error('Role toggle error', error);
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          console.error(error);
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
      }).finally(() => {
        this.loadingModules = false;
      });
    },
    fetchTenantModules() {
      // if set, keep the module-key here
      this.loadingModules = this.loadingModules || true;
      if (this.selectedTenantId === undefined) {
        return;
      }
      return Promise.all([ApiService.fetchDefaultRoles(this.getTenantById(this.selectedTenantId).scopeId, true), ApiService.tenantFetchModules(this.selectedTenantId)]).then(data => {
        this.tenantDefaultRoles = data[0];
        this.modules = data[1];
        const wmbusModule = data[1].find(d => d.manifest.key === 'wMBus');
        if (wmbusModule !== undefined && !wmbusModule.settings) {
          wmbusModule.settings = cloneDeep(DEFAULT_WMBUS_MODULE_SETTINGS);
        }
        const lwm2mModule = data[1].find(d => d.manifest.key === 'LwM2M');
        if (lwm2mModule !== undefined && !lwm2mModule.settings) {
          lwm2mModule.settings = cloneDeep(DEFAULT_LWM2M_MODULE_SETTINGS);
        }
        this.loadingModules = false;
      }).catch(error => {
        if (error.response && this.$i18n_t(`Error.${error.response.data.message}`)) {
          this.$snack(this.$i18n_t(`Error.${error.response.data.message}`), 'error');
        } else {
          console.error(error);
          this.$snack(this.$i18n_t('Common.oops1'), 'error');
        }
      });
    }
  }
};